import api from "../../../../axiosConfig";

// Obtener clientes filtrados por rol del usuario
export const fetchClientes = async () => {
  try {
    // Primero intentar obtener clientes filtrados por rol
    const response = await api.get(`/roles/clientes/usuario`);
    const { clientes, tiene_restriccion } = response.data;

    if (tiene_restriccion && clientes && clientes.length > 0) {
      // Mapear al formato esperado (id, nombre_cliente)
      return clientes.map(c => ({ id: c.id, nombre_cliente: c.nombre }));
    } else {
      // Sin restricción, cargar todos los clientes
      const allClientes = await api.get(`/clientes/list`);
      return allClientes.data || [];
    }
  } catch (error) {
    console.error("Error al obtener los clientes:", error);
    // Fallback: cargar todos los clientes
    try {
      const fallbackResponse = await api.get(`/clientes/list`);
      return fallbackResponse.data || [];
    } catch (fallbackError) {
      console.error("Error en fallback de clientes:", fallbackError);
      return [];
    }
  }
};

export const fetchCiudades = async (departamentoId) => {
  try {
    const response = await api.get(
      `/ciudades?departamento_id=${departamentoId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener ciudades:", error);
  }
};

export const fetchTiposDocumento = async () => {
  try {
    const response = await api.get(`/tipos-documento`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener tipos de documento:", error);
  }
};

export const fetchDepartamentos = async () => {
  try {
    const response = await api.get(`/departamentos`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener departamentos:", error);
  }
};

export const fetchZonas = async () => {
  try {
    const response = await api.get(`/zonas`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener zonas:", error);
  }
};

// Obtener solo las zonas disponibles para el rol del usuario
export const fetchZonasDisponibles = async () => {
  try {
    const response = await api.get(`/pacientes/zonas-disponibles`);
    return response.data.zonas || [];
  } catch (error) {
    console.error("Error al obtener zonas disponibles:", error);
    return [];
  }
};

export const fetchDiagnosticos = async () => {
  try {
    const response = await api.get(`/diagnosticos`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener diagnósticos:", error);
  }
};

export const fetchAfiliaciones = async () => {
  try {
    const response = await api.get(`/afiliaciones`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener afiliaciones:", error);
  }
};

export const fetchRegimenes = async () => {
  try {
    const response = await api.get(`/regimenes`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener regimenes:", error);
  }
};

export const fetchTipos = async () => {
  try {
    const response = await api.get(`/tipos`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener tipos:", error);
  }
};

export const fetchEstados = async () => {
  try {
    const response = await api.get(`/estados`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener estados:", error);
  }
};
